import { render } from "./CitaCita.vue?vue&type=template&id=486c87b7"
import script from "./CitaCita.vue?vue&type=script&lang=js"
export * from "./CitaCita.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__